import i18n from "../../constants/i18n";
import hasPermission from "../../helpers/et3-has-permission";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";

const Et3NoPermission = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const pageName = getCoreHistoryStore().pageName.get();
  const shouldShow = !hasPermission(pageName);

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="flex-end"
      withShadow={false}
      width={2000}
      height={1080}
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="center"
        alignItems="center"
        withShadow={false}
        width={1700}
        height={1080}
        color={colors.all.black}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={40}
          text={i18n.get("SORRY_NO_PERMISSION")}
          isSpan={false}
          color={colors.all.white}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default Et3NoPermission;
